import * as React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Grid2,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { useDispatch, useSelector } from "react-redux";
import Completebill from "./Completebill";
import TextInput from "../../components/Input/TextInput";
import { MuiPhoneComponent } from "../../components/Input/MuiPhoneComponent";
import { createGuest, getWebshopOpeningHours } from "../../api/Webshop.service";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import {
  resetKiosk,
  resetWebshop,
  setAdditionalFields,
  setCheckoutDetails,
  setGuestData,
  updateCheckoutDetails,
  updateGuestDetails,
  updateWebshopOpeningHours,
} from "../../store/slice/Webshop.slice";
import {
  setSingleProductTotalIncludeSupp,
  updateOrderNumberDetails,
  updateTotalPrice,
} from "../../store/slice/Webshop.slice";
import { CreateWebShopOrder } from "../../api/Webshop.service";
import dayjs from "dayjs";
import SelectComponent from "../../components/SelectComponent/SelectComponent";
import TimeSlots from "./TimeSlots";
import { useNavigate } from "react-router-dom";
import { format_Number, getCompanyStatus } from "../../utils/utils";
import CountrySelect from "../../components/SelectComponent/SelectCountry";
import DatePickerComponent from "../../components/SelectComponent/DatePicker";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const SummaryRow = ({ label, value, bold = false }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      mb: 1,
      fontWeight: bold ? "bold" : "normal",
    }}
  >
    <Typography>{label}</Typography>
    <Typography>{value}</Typography>
  </Box>
);

export default function Checkout({ open, handleClose, setOpen }) {
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);
  const cardCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "CardSectionWebshop"
  )?.fields
  const theme = useTheme();
  const currentDate = dayjs();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { webshopFileds } = useSelector((store) => store?.Webshop);
  const [loader, setLoader] = React.useState(false);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [completeBillOpen, setCompleteBillOpen] = React.useState(false);
  const {} = useSelector((store) => store?.Webshop);
  const {
    webShopMenuPosition,
    webshopOpeningHours,
    itemCount,
    addToCartProducts,
    supplementsInfo,
    webshopSettings,
    deliveryType,
    guestDetails,
    additionalFields,
    guestData,
    languageWords,
    singleProductTotalIncludeSupp,
    deliverySlots,
    CurrencyData,
    totalPrices,
  } = useSelector((store) => store?.Webshop);
  const [AddGuestLoader, setAddGuestLoader] = React.useState(false);
  const { key, resType } = useSelector((store) => store?.widgetSettings);
  const timeRef = React.useRef(null);
  const [isTimeComponent, setIsTimeComponent] = React.useState(false);
  const [totalVat, setTotalVat] = React.useState(0);
  const [totalPrice, setTotalPrice] = React.useState(0);
  const addGuestDetails = async (data) => {
   
    setAddGuestLoader(true);
    const guestDatas = webshopFileds?.map((field) => {
        const dataEntry = Object.entries(data).find(
          ([key]) => key === field.fieldName
        );
       
        if (dataEntry) {
          return {
            idfield: dataEntry[0],
            data: dataEntry[1],
          };
        } else {
          return {
            idfield: field.fieldName,
            data: "",
          };
        }
      });
    const additionalFieldsData = Object.entries(data)
      .filter(([key]) => !isNaN(Number(key)))
      .map(([key, value]) => ({
        webshopFieldId: Number(key),
        data: value,
      }));
  
    dispatch(setGuestData(guestDatas));
    dispatch(setAdditionalFields(additionalFieldsData));
  };
  const filteredFields = webshopFileds.filter((field) => {
    if (deliveryType === "pickup") return field.visibleInPickup;
    if (deliveryType === "delivery") return field.visibleInDelivery;
    if (deliveryType === "DineIn") return field.visibleInDineIn;
    return false;
  });

  const contentRef = React.useRef(null);
const sendHeight = React.useCallback(() => {
  if (!contentRef.current) return;

  const height = contentRef.current.scrollHeight + 120;

  send(`${height}px`, "100%", "", "0px", "0px", "", "relative");
}, []);

React.useLayoutEffect(() => {
  if (!contentRef.current) return;
  sendHeight();
}, []);

  const createOrderDetail = async (data) => {
    const extractSupplementIds = (supplements, detailsKey) => {
      return (
        supplements
          ?.filter((supItem) => supItem?.detailsKey === detailsKey)
          ?.map((supItem) => supItem?.idwebshopsupplementitem) || []
      );
    };
    const productItems = addToCartProducts?.map((item) => {
      const specialPrice = item?.specialPriceFields?.find((price) =>
        currentDate.isBetween(
          dayjs(price.specialpricefrom, "DD-MM-YYYY"),
          dayjs(price.specialpriceto, "DD-MM-YYYY"),
          null,
          "[]"
        )
      );

      const supplementsForProduct =
        supplementsInfo?.find(
          (supplement) => supplement?.idproduct === item?.idproduct
        )?.supplements || [];
      const supplementDetailsKeys = [
        "supplementProductsDetails1",
        "supplementProductsDetails2",
        "supplementProductsDetails3",
      ];

      const idSupplement1 = extractSupplementIds(
        supplementsForProduct,
        "supplementProductsDetails1"
      );
      const idSupplement2 = extractSupplementIds(
        supplementsForProduct,
        "supplementProductsDetails2"
      );
      const idSupplement3 = extractSupplementIds(
        supplementsForProduct,
        "supplementProductsDetails3"
      );

      return {
        webshopOrderItemId: 0,
        productId: item.idproduct,
        quantity: itemCount[item.idproduct],
        PriceWithoutSupplement: item.price,
        price: singleProductTotalIncludeSupp[item?.idproduct],
        isSpecialPrice: !!specialPrice,
        isRelatedProductPrice: item?.relatedproductprice ? true : false,
        idSupplement1: `[${idSupplement1.join(" ")}]`,
        idSupplement2: `[${idSupplement2.join(" ")}]`,
        idSupplement3: `[${idSupplement3.join(" ")}]`,
      };
    });
  
    const additionalFieldsData = Object.entries(data)
    .filter(([key]) => !isNaN(Number(key)))
    .map(([key, value]) => ({
      webshopFieldId: Number(key),
      data: value,
    }));
    const payload = {
      webshopOrder: {
        deliveryCost: webshopSettings?.deliveryStandardCost,
        selectedTime:
          data?.deliveryTime || data?.showPickTime || data?.DineInTime,
        totalVAT: totalVat,
        totalCost: webshopSettings?.pricesIncludingVAT
          ? totalPrice - totalVat
          : totalPrice,
        totalIncludingVAT: totalPrices,
        isPaid: true,
        isDelivery: deliveryType === "delivery",
        isDineIn: deliveryType === "DineIn",
        idguest: guestDetails?.value?.idguest || 0,
        paymentMethod: 2,
        isManualOrder: true,
        isKioskWidgetOrder: resType?.toLowerCase() == "kiosk",
        isWebshopOrder: resType?.toLowerCase() == "webshop",
      },
      webshopOrderItemsVM: productItems,
      key,
      guestData: guestData,
      additionalGuestData: additionalFieldsData,
    };
    setLoader(true);
    try {
      const response = await CreateWebShopOrder(payload);
      const { url, idOrder } = response.data;

      if (url && idOrder) {
        dispatch(updateOrderNumberDetails(response?.data));
        localStorage.setItem("orderId", idOrder);
        window.parent.postMessage(
          {
            redirectUrl: url,
          },
          "*"
        );

        window.location.href = url;
      } else {
        alert("Invalid response from server.");
      }

      setLoader(false);
      handleClose();
    } catch (error) {
      setLoader(false);
      console.error(error?.message);
    }
  };
  const calculateTotalPrice = React.useCallback(
    (onlyVat = false) => {
      let vatAmount;
      const totalProductsPrice = addToCartProducts?.reduce((acc, product) => {
        const supplementInfo = supplementsInfo?.find(
          (item) => item?.idproduct === product.idproduct
        );
        const supplementTotal =
          supplementInfo?.supplements?.reduce(
            (suppAcc, supplement) => suppAcc + (supplement?.price || 0),
            0
          ) || 0;
        // const productTotal =
        //   product.price * (itemCount[product.idproduct] || 0) +
        //   supplementTotal * (itemCount[product.idproduct] || 0);
        const quantity = itemCount[product.idproduct] || 0;

const specialPrice = product?.specialPriceFields?.find((price) =>
  currentDate.isBetween(
    dayjs(price.specialpricefrom, "DD-MM-YYYY"),
    dayjs(price.specialpriceto, "DD-MM-YYYY"),
    null,
    "[]"
  )
);

const unitPrice = product?.recommededProducts
  ? product?.relatedproductprice
  : specialPrice
  ? specialPrice?.specialprice
  : product?.price;

const productTotal =
  unitPrice * quantity +
  supplementTotal * quantity;


        dispatch(
          setSingleProductTotalIncludeSupp({
            ...singleProductTotalIncludeSupp,
            [product.idproduct]: productTotal,
          })
        );

        vatAmount =
           webshopSettings?.pricesIncludingVAT
            ? CalculateVat(productTotal, product?.vat || 0)
            : 0;
        return acc + productTotal + vatAmount;
      }, 0);

      if (onlyVat) {
        return vatAmount;
      }
      return totalProductsPrice;
    },
    [addToCartProducts, supplementsInfo, itemCount, webshopSettings]
  );

  function CalculateVat(price, vatPersentage) {
    const vat = (price / (vatPersentage + 100)) * vatPersentage;
    return Math.round(vat * 100) / 100;
  }

  const ProductPrice = (id, productPrice) => {
    const supplementInfo = supplementsInfo?.find(
      (item) => item?.idproduct == id
    );
    const supplementTotal =
      supplementInfo?.supplements?.reduce(
        (suppAcc, supplement) => suppAcc + (supplement?.price || 0),
        0
      ) || 0;

    const productTotal =
      productPrice * (itemCount[id] || 0) +
      supplementTotal * (itemCount[id] || 0);
    return productTotal;
  };
  React.useEffect(() => {
    const total = calculateTotalPrice();
    setTotalPrice(total);
    const vat = calculateTotalPrice(true);
    setTotalVat(vat);
  }, [calculateTotalPrice]);

  React.useEffect(() => {
    const overAllTotalPrice =
      totalPrice < webshopSettings?.freeDeliveryAfterAmount
        ? totalPrice + webshopSettings?.deliveryStandardCost
        : totalPrice;
    dispatch(updateTotalPrice(overAllTotalPrice));
  }, [totalPrice]);
  
  const generateFormConfig = (fields, deliveryType) => {
    let initialValues = {};
    let validationSchema = {};
  
    fields.forEach((field) => {
      const fieldKey = field?.isDefaultField
        ? field.fieldName
        : field.webshopFieldId;
      initialValues[fieldKey] = "";
  
      // Validation
      if (field.fieldName === "Email") {
        validationSchema[fieldKey] = Yup.string()
          .email("Invalid email")
          .required("Email is required");
      } 
      else if (field.fieldName === "Telefoon") {
        validationSchema[fieldKey] = Yup.string()
          .required("Phone is required");
      } 
      else {
        validationSchema[fieldKey] = Yup.string()
          .required(`${field.fieldName} is required`);
      }
    });
    if (webshopSettings?.showPickupTimeWidget) {
      initialValues.showPickTime = "";
      validationSchema.showPickTime = Yup.string().required(
        "Pick time is required"
      );
    }
    if (webshopSettings?.showDeliveryWebshopWidget) {
      initialValues.deliveryTime = "";
      validationSchema.deliveryTime = Yup.string().required(
        "Delivery time is required"
      );
    }
    if (webshopSettings?.CustomerRequestedDineInTime) {
      initialValues.dineInTime = "";
      validationSchema.dineInTime = Yup.string().required(
        "Dine in time is required"
      );
    }
  
    return {
      initialValues,
      validationSchema: Yup.object(validationSchema),
    };
  };
  const { initialValues, validationSchema } = generateFormConfig(
    filteredFields,
    deliveryType
  );


  

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
  
    onSubmit: (values) => {
     
      dispatch(updateCheckoutDetails(values));
      addGuestDetails(values);
      createOrderDetail(values);
    },
  });
  const send = (
    frameHeight,
    frameWidth,
    top,
    right,
    bottom,
    left,
    floating,
    redirectUrl
  ) => {
    window.parent.postMessage(
      {
        reservationIframeHeight: frameHeight,
        reservationIframeWidth: frameWidth,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl: redirectUrl,
      },
      "*"
    );
  };
  return (
    <React.Fragment>
      {webShopMenuPosition == "null" &&
        !getCompanyStatus(
          webshopOpeningHours?.value?.data?.openTime,
          webshopOpeningHours?.value?.data?.closeTime,
          webshopOpeningHours?.value?.data?.companyOpen,
          webshopOpeningHours?.value?.data?.deliveryFrom,
          webshopOpeningHours?.value?.data?.deliveryTo,
          webshopOpeningHours?.value?.data?.delivery,
          deliveryType
        )?.status && (
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#fff3f3",
              borderBottom: "1px solid #f44336",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
              textAlign: "center",
              py: 1.5,
            }}
          >
            <Typography
              sx={{
                color: "#c62828",
                fontWeight: 600,
                fontSize: "1.1rem",
                fontFamily: "Roboto, sans-serif",
                letterSpacing: "0.5px",
              }}
            >
              {
                getCompanyStatus(
                  webshopOpeningHours?.value?.data?.openTime,
                  webshopOpeningHours?.value?.data?.closeTime,
                  webshopOpeningHours?.value?.data?.companyOpen,
                  webshopOpeningHours?.value?.data?.deliveryFrom,
                  webshopOpeningHours?.value?.data?.deliveryTo,
                  webshopOpeningHours?.value?.data?.delivery,
                  deliveryType
                )?.message
              }
            </Typography>
          </Box>
        )}
     
      <Box
      ref={contentRef}
        sx={{
          width: "100%",
          ml:
            webShopMenuPosition == "vertical"
              ? isSmallScreen
                ? "60px"
                : "120px"
              : 0,
          p: 1,
          backgroundColor: "#fff",
          minHeight: "85vh",
          position: "relative",
        }}
      >
        <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
          <IconButton
            color="warning"
            onClick={() => {
              if (addToCartProducts?.length == 0) {
                navigate(webShopMenuPosition ? "/webshopMenuItem" : "/menu");
              } else {
                navigate(-1);
              }
            }}
          >
            <ArrowBackIosNewRoundedIcon />
          </IconButton>
          <Typography
            sx={{
              color: "#F37120",
              fontWeight: 700,
              fontSize: "2rem",
              ml: 1,
            }}
          >
            {languageWords?.Checkout}
          </Typography>
        </Box>
        <form

        //   onSubmit={formik.handleSubmit}
        >
          <DialogContent sx={{ mt: 2 }}>
            <Grid2 container>
              <Grid2 size={{ md: 7, sm: 12, xs: 12 }}>
                <Grid
                  container
                  spacing={2}
                  alignItems={"center"}
                  sx={{ width: "100%" }}
                >
         {filteredFields?.map((field, i) => {
  const fieldKey = field?.isDefaultField
    ? field.fieldName
    : field.webshopFieldId;

  switch (field?.fieldName) {
    case "salutation":
      return (
        <Box sx={{ mt: 1 }} key={i}>
          <InputLabel
            sx={{
              fontWeight: "bold",
              fontSize: "15px",
              color: theme?.details?.formLabelColor,
            }}
          >
            {
              field?.guestLanguages?.find(
                (item) => item?.fieldname === "name"
              )?.data
            }
          </InputLabel>

          <FormControl>
            <RadioGroup
              row
              name={fieldKey}
              value={formik.values[fieldKey]}
              onChange={(e) =>
                formik.setFieldValue(fieldKey, e.target.value)
              }
            >
              {field?.guestLanguages?.[1]?.data
                ?.replace(/\\"/g, "")
                ?.split("\n")
                ?.map((item) =>
                  item.trim().replace(/^"|"$/g, "")
                )
                ?.filter(Boolean)
                ?.map((item) => (
                  <FormControlLabel
                    key={item}
                    value={item}
                    control={
                      <Radio
                        size="small"
                        sx={{
                          "&.Mui-checked": {
                            color: theme?.palette?.themeColor,
                          },
                        }}
                      />
                    }
                    label={
                      <span
                        style={{
                          color: "#969BA0",
                          fontSize: "16px",
                        }}
                      >
                        {item}
                      </span>
                    }
                  />
                ))}
            </RadioGroup>
          </FormControl>
        </Box>
      );

    case "County":
      return (
        <Box sx={{ mt: 2, width: "100%" }} key={i}>
          <CountrySelect
            label={field?.fieldName}
            showLabel={true}
            name={fieldKey}
            value={formik.values[fieldKey]}
            onChange={formik.setFieldValue}
            error={
              formik.touched[fieldKey] &&
              Boolean(formik.errors[fieldKey])
            }
            helperText={
              formik.touched[fieldKey] &&
              formik.errors[fieldKey]
            }
            style={{ width: "100%" }}
          />
        </Box>
      );

    case "date":
      return (
        <Grid2 size={{ xs: 12, md: 6 }} key={i} mt={1}>
          <DatePickerComponent
            name={fieldKey}
            label={field?.fieldName}
            showLabel={true}
            value={formik.values[fieldKey]}
            onChange={formik.setFieldValue}
            error={
              formik.touched[fieldKey] &&
              Boolean(formik.errors[fieldKey])
            }
            helperText={
              formik.touched[fieldKey] &&
              formik.errors[fieldKey]
            }
          />
        </Grid2>
      );

    case "Email":
      return (
        <Grid2 size={{ xs: 12 }} key={i} mt={1}>
          <TextInput
            showLabel={true}
            name={fieldKey}
            label={field?.fieldName}
            value={formik.values[fieldKey]}
            onChange={formik.setFieldValue}
            error={
              formik.touched[fieldKey] &&
              Boolean(formik.errors[fieldKey])
            }
            helperText={
              formik.touched[fieldKey] &&
              formik.errors[fieldKey]
            }
          />
        </Grid2>
      );

    case "Telefoon":
      return (
        <Box sx={{ mt: 2 }} key={i}>
          <MuiPhoneComponent
            style={{ width: "100%" }}
            label={languageWords?.phone}
            showLabel={true}
            name={fieldKey}
            value={formik.values[fieldKey]}
            onChange={formik.setFieldValue}
            error={
              formik.touched[fieldKey] &&
              Boolean(formik.errors[fieldKey])
            }
            helperText={
              formik.touched[fieldKey] &&
              formik.errors[fieldKey]
            }
          />
        </Box>
      );

    default:
      return (
        <Grid2 size={{ xs: 12 }} key={i} mt={1}>
          <TextInput
            showLabel={true}
            name={fieldKey}
            label={field?.fieldName}
            value={formik.values[fieldKey]}
            onChange={formik.setFieldValue}
            error={
              formik.touched[fieldKey] &&
              Boolean(formik.errors[fieldKey])
            }
            helperText={
              formik.touched[fieldKey] &&
              formik.errors[fieldKey]
            }
          />
        </Grid2>
      );
  }
})}


                  <Grid item md={12} sm={12} xs={12}>
                    {webshopSettings?.showDeliveryWebshopWidget && (
                      <>
                        <Grid
                          item
                          xs={12}
                          md={12}
                          lg={12}
                          sx={{ mt: isSmallScreen ? 2 : 4 }}
                        >
                          <SelectComponent
                            label={"Requested Delivery Time"}
                            value={
                              formik?.values?.deliveryTime?.trim() != ""
                                ? deliverySlots[0]?.deliveryTime ==
                                  formik?.values?.deliveryTime
                                  ? "As soon as possible"
                                  : formik?.values?.deliveryTime
                                : "HH:MM"
                            }
                            onClick={() => setIsTimeComponent(!isTimeComponent)}
                            ref={timeRef}
                            validationSchema={
                              formik?.values?.deliveryTime?.trim() == ""
                            }
                            height={60}
                          />
                          <TimeSlots
                            name={"deliveryTime"}
                            onChange={formik.setFieldValue}
                            isOpen={isTimeComponent}
                            handleClose={() => setIsTimeComponent(false)}
                            Ref={timeRef.current}
                          />
                        </Grid>
                      </>
                    )}
                  </Grid>
                  <Grid item md={12} sm={12} xs={12}>
                    {webshopSettings?.showPickupTimeWidget && (
                      <>
                        <Grid
                          item
                          xs={12}
                          md={12}
                          lg={12}
                          sx={{ mt: isSmallScreen ? 2 : 4 }}
                        >
                          <SelectComponent
                            label={"Requested Pickup Time"}
                            value={
                              formik?.values?.showPickTime?.trim() != ""
                                ? formik?.values?.showPickTime
                                : "HH:MM"
                            }
                            onClick={() => setIsTimeComponent(!isTimeComponent)}
                            ref={timeRef}
                            validationSchema={
                              formik?.values?.showPickTime?.trim() == ""
                            }
                            height={60}
                          />
                          <TimeSlots
                            name={"Pickup Time"}
                            onChange={formik.setFieldValue}
                            isOpen={isTimeComponent}
                            handleClose={() => setIsTimeComponent(false)}
                            Ref={timeRef.current}
                          />
                        </Grid>
                      </>
                    )}
                    {webshopSettings?.CustomerRequestedDineInTime && (
                      <>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          lg={12}
                          sx={{ mt: isSmallScreen ? 2 : 4 }}
                        >
                          <SelectComponent
                            label={"Requested DineIn Time"}
                            value={
                              formik?.values?.showPickTime?.trim() != ""
                                ? formik?.values?.dineInTime
                                : "HH:MM"
                            }
                            onClick={() => setIsTimeComponent(!isTimeComponent)}
                            ref={timeRef}
                            validationSchema={
                              formik?.values?.showPickTime?.trim() == ""
                            }
                            height={60}
                          />
                          <TimeSlots
                            name={"DineIn Time"}
                            onChange={formik.setFieldValue}
                            isOpen={isTimeComponent}
                            handleClose={() => setIsTimeComponent(false)}
                            Ref={timeRef.current}
                          />
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid2>
              <Grid2
                size={{ md: 5, sm: 12, xs: 12 }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    bgcolor:cardCss?.cardSectionBgColor,
                    p: 3,
                    borderRadius: 3,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    width: isSmallScreen ? "100%" : "70%",
                    maxHeight: "250px",
                    mt: 4,
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 ,color:cardCss?.cardSectionTitleClr}}>
                    Product Details
                  </Typography>
                  {addToCartProducts?.map((item, index) => {
  const specialPrice = item?.specialPriceFields?.find((price) =>
    currentDate.isBetween(
      dayjs(price.specialpricefrom, "DD-MM-YYYY"),
      dayjs(price.specialpriceto, "DD-MM-YYYY"),
      null,
      "[]"
    )
  );

  return (
    <SummaryRow
      key={index}
      label={item?.displayname || item?.displayName}
      value={`${CurrencyData?.value?.currencySymbol} ${format_Number(
        ProductPrice(
          item?.idproduct,
          item?.recommededProducts
            ? item?.relatedproductprice
            : specialPrice
            ? specialPrice?.specialprice
            : item?.price
        )
      )}`}
    />
  );
})}


                  <Divider sx={{ my: 2 }} />
                </Box>
                <Box
                  sx={{
                    bgcolor:cardCss?.cardSectionBgColor,
                    p: 3,
                    borderRadius: 3,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    width: isSmallScreen ? "100%" : "70%",
                    maxHeight: "250px",
                    mt: 4,
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2,color:cardCss?.cardSectionTitleClr }}>
                    {languageWords?.OrderSummary}
                  </Typography>

                  {totalPrice < webshopSettings?.freeDeliveryAfterAmount && (
                    <SummaryRow
                      label={languageWords?.deliverycost}
                      value={`${
                        CurrencyData?.value?.currencySymbol
                      } ${format_Number(
                        webshopSettings?.deliveryStandardCost
                      )}`}
                    />
                  )}

                  {totalVat > 0 && <SummaryRow
                    label={languageWords?.VAT}
                    value={`${
                      CurrencyData?.value?.currencySymbol
                    } ${format_Number(totalVat)}`}
                  />}

                  <Divider sx={{ my: 2 }} />

                  <SummaryRow
                    label={languageWords?.TotalIncludingVAT}
                    value={`${
                      CurrencyData?.value?.currencySymbol
                    } ${format_Number(
                      totalPrice < webshopSettings?.freeDeliveryAfterAmount
                        ? totalPrice + webshopSettings?.deliveryStandardCost
                        : totalPrice
                    )}`}
                    bold
                  />
                </Box>
                <Button
                  //type="submit"
                  type="button"
                  onClick={() => {
                  

                    formik.handleSubmit();

                    setTimeout(() => {
                      console.log("Errors after submit:", formik.errors);
                    }, 0);
                  }}
                  disabled={
                    !getCompanyStatus(
                      webshopOpeningHours?.value?.data?.openTime,
                      webshopOpeningHours?.value?.data?.closeTime,
                      webshopOpeningHours?.value?.data?.companyOpen,
                      webshopOpeningHours?.value?.data?.deliveryFrom,
                      webshopOpeningHours?.value?.data?.deliveryTo,
                      webshopOpeningHours?.value?.data?.delivery,
                      deliveryType
                    )?.status
                  }
                  sx={{
                    backgroundColor: "#F37120",
                    color: "#fff",
                    py: 2,
                    mt: 1,
                    width: "70%",
                    mt: 3,
                  }}
                >
                  {loader ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                    {languageWords?.PayNow}{" "}
                    {totalPrice > 0 && (
                      <>
                        {CurrencyData?.value?.currencySymbol}{" "}
                        {format_Number(totalPrice)}
                      </>
                    )}
                  </>
                  
                  )}
                </Button>
                {!getCompanyStatus(
                  webshopOpeningHours?.value?.data?.openTime,
                  webshopOpeningHours?.value?.data?.closeTime,
                  webshopOpeningHours?.value?.data?.companyOpen,
                  webshopOpeningHours?.value?.data?.deliveryFrom,
                  webshopOpeningHours?.value?.data?.deliveryTo,
                  webshopOpeningHours?.value?.data?.delivery,
                  deliveryType
                )?.status && (
                  <Typography
                    sx={{ color: "grey", textAlign: "center", mt: 1 }}
                  >
                    {" "}
                    We are closed not able to place an order .
                  </Typography>
                )}
              </Grid2>
            </Grid2>
          </DialogContent>
        </form>
      </Box>
      <Completebill
        open={completeBillOpen}
        handleClose={() => setCompleteBillOpen(false)}
        back={() => setOpen(true)}
      />
    
    </React.Fragment>
  );
}
